import { GarmentMeasurements, ValidGarmentMeasurement, garmentMeasurementLabels } from "../types/measurement-data/garment-types";

export const getValidGarmentMeasurements = (measurements: GarmentMeasurements): ValidGarmentMeasurement[] => {
  if (!measurements || Object.keys(measurements).length === 0) {
    return [];
  }

  return Object.entries(measurements)
    .filter(([key, value]) => value && typeof value.Size === "number" && value.Size > 0)
    .map(([key, value]) => ({
      key,
      value: value!.Size,
      label: garmentMeasurementLabels[key] || key,
    }));
};
